module.exports = __webpack_public_path__ + "static/media/nav_trivia.368cd975.svg";